import Component from './Component';

let that = {};
let countZaiusCheck = 0;
export default class AnalyticsOdp extends Component {
  load() {
    that = this;
    that.initAnalyticsOdpAsync();
    super.load();
  }

  async initAnalyticsOdpAsync() {
    await that.runIsValidAddAnalyticsWithWait(that.initAnalyticsOdp);
  }

  initAnalyticsOdp() {
    // zaius must be loaded, by marketing/SEO scripts.
    if (!window.zaius) {
      console.warn('zaius not loaded');
      return;
    }
    console.log('zaius is loaded');

    that.sendHashEmailToODP();

    // Add sa only whole site events
    if(that.siteIs('sa')) {
      that.addTravelPartnerEvents();
    }

    if(!that.siteIs('corp') && !that.siteIs('trade')) {
      that.addSubscribeEvents();
    }

    // Add product page events
    const product = that.getProductDetails();
    if(!product) return;

    that.productPageEvents(product);
    that.addClickEvents(product);
  }

  // sendAdobeCloudIdToODP() {
  //   // Send the user cloud id to ODP
  //   //Getting the alternative cookies from the
  //
  //   if (_satellite?.getVisitorId()) {
  //     window.zaius.event('pageview', {
  //       adobe_experience_cloud_id: _satellite.getVisitorId()._fields.MCMID
  //     });
  //   } else {
  //     console.log('_satellite value is empty or not set yet');
  //   }
  // }

  checkCookieName(name) {
    const cookieArr = document.cookie.split('; ');

    for(let i = 0; i < cookieArr.length; i++) {
      const cookiePair = cookieArr[i].split('=');

      if(name === cookiePair[0]) {
        return decodeURIComponent(cookiePair[1]);
      }
    }

    return null;
  }


  sendHashEmailToODP() {
    const utmEmail = that.getEmailHashFromURL("utm_email");

    if (utmEmail === 'Invalid SHA-256 format') {
      console.log(utmEmail);
    } else if(utmEmail) {
      window.zaius.customer({
        sha256_email_hash: utmEmail
      }, {...that.getPRID()});
    }
  }

  getPRID() {
    const profileValues = buildAfxProfileValues();
    if (profileValues?.prid) {
      const hcSatcId = profileValues.prid;
      
      // Store hc_satc_id in localStorage
      localStorage.setItem("hc_satc_id", hcSatcId);
      return { "hc_satc_id": hcSatcId }; // Return as an object
    } else {        
      console.log("prid is not available.");
      return null; // Return null if prid is not available
    }
  }

  buildAfxProfileValues() {
    // Get the `afx_profile` cookie value
    const cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith('afx_profile='))
      ?.split('=')[1];
    
    if (!cookieValue) {
      return { acid: null, prid: null };
    }
    // Decode the cookie JSON string and parse it
    const afxProfile = JSON.parse(decodeURIComponent(cookieValue));
    // Extract the acid and prid values
    const acid = afxProfile.acid || null;
    const prid = afxProfile.prid || null;
    return { acid, prid };
  }

  sendIdsToODP() {
    if (typeof _satellite === 'undefined') {
      console.warn('_satellite not loaded');
      return;
    }

    let adFixusProfileId = this.checkCookieName('afx_profile');
    let adFixusObject = {};

    if(adFixusProfileId) {
      adFixusObject = JSON.parse(adFixusProfileId);
    }

    const prid = adFixusObject?.prid;
    const acid = adFixusObject?.acid;
    const mcid = _satellite?.getVisitorId()?._fields?.MCMID;
    let data = {};
    console.log(prid, acid, mcid);

    if(prid) {
      data.satc_id = prid;
    }
    if(acid) {
      data.satc_id_hash = acid;
    }
    if(mcid) {
      data.adobe_experience_cloud_id = mcid;
    }

    window.zaius.event('pageview', data);
  }

  waitForOptanonActiveGroups() {
    return new Promise((resolve) => {
      const checkVariable = () => {
        if (typeof OptanonActiveGroups !== 'undefined') {
          console.log('OptanonActiveGroups 1');
          resolve();
        } else {
          setTimeout(checkVariable, 1000);
        }
      };
      checkVariable();
    });
  }

  async runIsValidAddAnalyticsWithWait(callback) {
    console.log('runIsValidAddAnalyticsWithWait');
    const result = await this.waitForOptanonActiveGroups();
    callback();
  }

  getEmailHashFromURL(name) {
    const url = new URL(window.location.href);
    const paramValue = url.searchParams.get(name);

    // Validation
    if (paramValue && typeof paramValue === 'string') {
      // Regular expression to check if the string is a SHA-256 hash
      const sha256Regex = /^[a-fA-F0-9]{64}$/;
      if (sha256Regex.test(paramValue)) {
        return paramValue;
      } else {
        return 'Invalid SHA-256 format';
      }
    }

    return null; // Return null if the query parameter is not found or invalid
  }

  getProductDetails() {
    const productOnPage = document.getElementById("contactAddress");

    if(productOnPage) {
      let product = {};
      product.Name = productOnPage.getAttribute('productname');
      product.Type = productOnPage.getAttribute('producttype');
      product.Location = productOnPage.getAttribute('productlocation');
      product.Id = that.getProductIdFromIwtOrAtdw(productOnPage.getAttribute('productid'));

      if(product.Id && product.Name && product.Type && product.Location) {
        return product;
      }
    }
  }

  addTravelPartnerEvents() {
    const partner = document.querySelectorAll("a.type-airline");
    if(partner && window.zaius) {
      partner.forEach(element => element.addEventListener("click", (partner) => {
        const href = element.getAttribute('href');
        const partnerUrl = href.substring(0, href.indexOf('?'));
        console.log('click_partner_link');
        window.zaius.event("Travel Partner", {
          action: "click_partner_link",
          partner_link: partnerUrl,
        });
      }));
    }
  }

  productPageEvents(product) {
    /*
    *  On product detail page load, execute the following script to create/update the product
    */
    if(!window.zaius) return;

    window.zaius.entity("product", {
      product_id: product.Id, // map to product id
      name: product.Name, // map to product name
      product_type: product.Type, // map top product type
      product_location: product.Location, // custom field maps to product location
    });

    /*
    *  On product detail page load, execute the following script
    *  Ref: https://docs.developers.optimizely.com/digital-experience-platform/v1.5.0-optimizely-data-platform/docs/websdk-events#details-viewed
    */
    window.zaius.event("product", {
      action: "detail",
      product_id: product.Id,
      // email:"vincent.yang@optimizely.com"  //(optional, depends on login status)
    });
  }

  addSubscribeEvents() {
    if(!window.location.pathname.startsWith('/newsletter-sign'))
      return;

    const subListId = document.querySelector('meta[name="opt.sub.list.id"]');
    if(!subListId) return;

    // console.log('addSubscribeEvents');
    const formControls = Array.from(document.querySelectorAll(".umbraco-forms-form input, .umbraco-forms-form select"));
    const submit = document.querySelectorAll(".umbraco-forms-form .js-form-submit");
    // const form = document.querySelectorAll('form[action="/newsletter-signup"]');

    //document.getElementById(`.form-control [data-alias="${name}"]`).value;
    const getFormValue = (name) => {
      const el = formControls.find(el => el.getAttribute('data-alias') === name);

      if(el) {
        if(el.nodeName.toLowerCase() === 'select')
          return el.options[el.selectedIndex].value;

        // that will catch the privacy policy field and return false if not checked
        if(el.className.includes('input-validation-error'))
          return false;

        return el.value;
      }

      return '';
    };

    // Get elements from form
    if(formControls && formControls.length > 0 && submit && submit.length > 0) {
      submit[0].addEventListener('click', (event) => {
        const user = {
          email: getFormValue('email'),
          fName: getFormValue('firstName'),
          lName: getFormValue('lastName'),
          postcode: getFormValue('postCode'),
          country: getFormValue('country'),
          stateDd: getFormValue('stateDropdown'),
          stateText: getFormValue('stateText'),
          agree: getFormValue('iHaveReadAndAgreeToThePrivacyPolicy'),
        };

        // console.log(user);
        that.sendSubscribeEvent(user, subListId.getAttribute('content'));
      });
    }

    return;

    // submit.forEach(element => element.addEventListener("submit", function() {
    //
    // }));
  }

  sendSubscribeEvent(user, subListId) {
    if(!user || !user.email || !user.fName || !user.lName || !user.agree || !subListId || !window.zaius)
      return;

    const state = user.stateText ? user.stateText : user.stateDd;

    (async () => {
      const result = await that.hash(user.email);
      window.zaius.customer({
        email: user.email,
        sha256_email_hash: `${result}`
      },
      {
        ...that.getPRID()
      }
    );

      window.zaius.consent({
        email: user.email,
        consent: true
      });
    })();

  }

  addClickEvents(product) {
    /*
    *  On elements click, execute the following script
    *  Ref: https://docs.developers.optimizely.com/digital-experience-platform/v1.5.0-optimizely-data-platform/docs/websdk-custom-events
    */
    const phone = document.querySelectorAll(".js-contact-info-phone");
    const email = document.querySelectorAll(".js-contact-info-email");
    const enquire = document.querySelectorAll(".js-booking-box-enquire, .js-contact-info-enquire");
    const book = document.querySelectorAll(".js-booking-box-book, .js-contact-info-book");
    const deal = document.querySelectorAll(".js-booking-box-deal");
    const productId = that.getProductIdFromIwtOrAtdw(product.Id);

    if(phone) {
      phone.forEach(element => element.addEventListener("click", function() {
        window.zaius.event("ATDW", {
          action: "click_to_call",
          product_id: productId,
        });
      }));
    }
    if(email) {
      email.forEach(element => element.addEventListener("click", function() {
        window.zaius.event("ATDW", {
          action: "click_to_email",
          product_id: productId,
        });
      }));
    }
    if(enquire) {
      enquire.forEach(element => element.addEventListener("click", function() {
        window.zaius.event("ATDW", {
          action: "click_to_enquire",
          product_id: productId,
        });
      }));
    }
    if(book) {
      book.forEach(element => element.addEventListener("click", function() {
        window.zaius.event("ATDW", {
          action: "click_to_book",
          product_id: productId,
        });
      }));
    }
    if(deal) {
      deal.forEach(element => element.addEventListener("click", function() {
        window.zaius.event("ATDW", {
          action: "click_to_deal",
          product_id: productId,
        });
      }));
    }
  }

  getProductIdFromIwtOrAtdw(productIdAtdw) {
    const bookButton = document.querySelectorAll(".iwt-add-to-card-btn");

    // Return IWT ID if present, else return ATDW ID
    if (bookButton && bookButton.length > 0) {
      const url = bookButton[0].getAttribute('data-iframe-src');
      if (!url) return productIdAtdw; // previously producId undefined

      if (url.includes('ticket.com.au')) {
        const indexOfIdEnd = url.indexOf('?');
        const iwtId = url.substring(indexOfIdEnd - 7, indexOfIdEnd);
        return atob(iwtId);
      }
    }

    return productIdAtdw;
  }

  siteIs(siteCode) {
    if(!window.sitecode) {
      window.sitecode = document.querySelector('meta[name="sitecode"]')?.getAttribute('content').toLocaleLowerCase();
    }
    return siteCode === window.sitecode;
  }

  hash(string) {
    const utf8 = new TextEncoder().encode(string);
    return crypto.subtle.digest('SHA-256', utf8).then((hashBuffer) => {
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray
        .map((bytes) => bytes.toString(16).padStart(2, '0'))
        .join('');
      return hashHex;
    });
  }

  // that code is duplicated from the CMS site settings of most sites
  waitForOptanonActiveGroups() {
    return new Promise((resolve) => {
      const checkVariable = () => {
        countZaiusCheck++;
        if ((typeof OptanonActiveGroups !== 'undefined' && OptanonActiveGroups.indexOf(',C0001,') !== -1 && window.zaius) || countZaiusCheck > 10) {
          resolve();
        } else {
          setTimeout(checkVariable, 1000);
        }
      };
      checkVariable();
    });
  }

  async runIsValidAddAnalyticsWithWait(callback) {
    const result = await that.waitForOptanonActiveGroups();
    // Run main analytics groups
    callback();
  }

}
